import { styled } from "@/stitches/config"

export const SFormLabel = styled("label", {})
